import { gql, useQuery } from '@apollo/client'
import { BoundCanProps, createCanBoundTo } from '@casl/react'
import { createContext, useContext, useEffect, useState } from 'react'
import { Abilities, importAbilities } from './index'
import { GetAbilitiesQuery } from './__generated__/GetAbilitiesQuery'

export const AbilityContext = createContext<AbilityContextType>(undefined)

export type AbilityContextType = {
  abilities: Abilities
  logout: () => void
}

export const AbilityProvider = ({ children }) => {
  const { data } = useQuery<GetAbilitiesQuery>(getAbilitiesQuery)
  const [abilities, setAbilities] = useState<Abilities>(undefined)

  useEffect(() => {
    if (data?.viewer?.abilities) {
      const getAbilities = importAbilities(JSON.parse(data.viewer.abilities))
      setAbilities(getAbilities)
    }
  }, [data])

  const result: AbilityContextType = {
    abilities,
    logout: () => {
      setAbilities(undefined)
    },
  }

  return <AbilityContext.Provider value={result}>{children}</AbilityContext.Provider>
}

const getAbilitiesQuery = gql`
  query GetAbilitiesQuery {
    viewer {
      abilities
    }
  }
`

export const useAbilities = () => {
  return useContext<AbilityContextType>(AbilityContext)
}

export const Can = (props: BoundCanProps<Abilities>) => {
  const { abilities } = useAbilities()

  if (abilities) {
    const CanBound = createCanBoundTo<Abilities>(abilities)

    return <CanBound {...props} />
  } else {
    return <></>
  }
}

export default useAbilities
